import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Inject, Injectable, NgZone } from '@angular/core';

import { StreamCreatedEvent } from '../../publisher.model';
import { distinctUntilChanged } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EnvironmentService } from '../../../../../../services/enviroment/environment.service';
import { StateHandlerService } from '../../../../../../services/state-handler/state-handler.service';
import { videocallTestQuality } from './test-quality-vonage';


@Injectable({
  providedIn: 'root',
})
export class TestQualityService {
  subscriberTest?: OT.Subscriber;
  session?: OT.Session;
  publisher?: OT.Publisher;
  publisherStream?: StreamCreatedEvent;
  forceTestStopBS: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private forceTestSTop$: Observable<boolean> =
    this.forceTestStopBS.asObservable();
  showLostSignalModalBS: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private videoMosMinValue: number;
  private videoBitrateMinValue: number;
  private bandwidthTestInterval: number;
  private _cameraStatusBS: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private get cameraStatusBS():boolean {
    return this._cameraStatusBS.getValue();
  }
  private set cameraStatusBS(value: boolean) {
    this._cameraStatusBS.next(value);  }

  private get $cameraStatusBS(): Observable<boolean>{
    return this._cameraStatusBS.asObservable();
  }

  private videoButtonSubscription?: Subscription;

  constructor(
    private readonly environmentService: EnvironmentService,
    private readonly stateHandlerSvc: StateHandlerService
  ) {
    /**
     * Supported from mos values
     */
    this.videoMosMinValue =
      this.environmentService.data?.someParams?.minMosRequiredNetworkTest?? 1.7;
    this.videoBitrateMinValue =
      this.environmentService.data?.someParams?.minBitrateRequiredNetworkTest?? 50000;
    this.bandwidthTestInterval =
      this.environmentService.data?.someParams?.bandwidthTestInterval ?? 30000;
    this.showLostSignalModalBS.next(false);
  }

  getshowLostSignalModalBS$() {
    return this.showLostSignalModalBS.asObservable().pipe(distinctUntilChanged());
  }

  initTestSubscriber(
    session: OT.Session,
    publisher: OT.Publisher,
    event: StreamCreatedEvent
  ) {
    this.publisher = publisher;
    this.session = session;
    const containerDiv = document.createElement('div');
    containerDiv.style.position = 'fixed';
    containerDiv.style.bottom = '-1px';
    containerDiv.style.width = '1px';
    containerDiv.style.height = '1px';
    containerDiv.style.opacity = '0';
    document.body.appendChild(containerDiv);
    new Promise((resolve, reject) => {
      const subscriber = session.subscribe(
        event.stream,
        containerDiv,
        { testNetwork: true, insertMode: 'append' },
        (subscribeError?: OT.OTError) => {
          console.log('initTestSubscriber error: ', subscribeError);
          return subscribeError
            ? reject(null)
            : resolve({ publisher, subscriber });
        }
      );
    }).then((value: any) => { //{ publisher: OT.Publisher; subscriber: OT.Subscriber }
      if (value) {
        this.subscriberTest = value.subscriber as OT.Subscriber;
        this.publisherStream = event;
        this.initTestQuality(this.publisher as OT.Publisher, this.session as OT.Session, this.subscriberTest );
      }
    });
  }

  initTestQuality(
    publisher: OT.Publisher,
    session: OT.Session,
    subscriberTest: OT.Subscriber
  ) {
    console.log('initTestQuality *********************');
    this.videoButtonSubscription = this.stateHandlerSvc
      .get('cameraStatusTestQuality')
      .subscribe((cameraAtivated) => {
        this.cameraStatusBS = cameraAtivated;
      });
    const onUpdateParams = {
      videoMosMinValue: this.videoMosMinValue,
      videoBitrateMinValue: this.videoBitrateMinValue,
      bandwidthTestInterval: this.bandwidthTestInterval,
      cameraStatusBS: this.$cameraStatusBS
    };
    videocallTestQuality(
      session,
      publisher,
      subscriberTest,
      this.forceTestSTop$,
      undefined,
      this.onUpdate,
      onUpdateParams,
      this
    ).then((results) => {
      this.onUpdate(results, onUpdateParams, session, this);
    });
  }

  onUpdate(results: any, params: any, session: OT.Session, that: any) {
    console.log('TestQuality onUpdate RESULTS: ', results);
    let cameraActivated:boolean = false;
    cameraActivated = that?._cameraStatusBS?.getValue() || this.cameraStatusBS;
    // params.cameraStatusBS.subscribe((value: any)=>{
    //   cameraActivated = value;
    // });
    if (results.video.bitrate > 0) {
      let networkTest = !results.video.reason && (results.video.bitrate >= params.videoBitrateMinValue);
      console.log('TestQuality onUpdate supported: ', results.video.supported);
      console.log('TestQuality onUpdate cameraActivated: ', cameraActivated);
      if (!networkTest && cameraActivated) {
        session.signal({ data: 'insufficient', type: 'bandwidth' }, (error) => {
          if (error) {
            console.log('signal error (' + error.name + '): ' + error.message);
          } else {
            console.log('signal sent.');
          }
        });
      }

      console.log(
        'TestQuality onUpdate videoMosMinValue:',
        params.videoMosMinValue
      );
      console.log('TestQuality onUpdate results.video.mos:', results.video.mos);
      console.log('TestQuality onUpdate networkTest:', networkTest);
    } else {

      //Si no ha perdido la conexión (errores q paran la ejecución de javascript) antes de recibir los datos
      if (that?.showLostSignalModalBS) {
        console.log('LOST SIGNAL **********************', results);
        //Si se reliza f5 en videoconferencia-main se evalúa q se ha perdido la conexión y enruta a mutua-test
        localStorage.setItem('lostSignalRedirect', 'true');
        that.showLostSignalModalBS.next(true);
      } else {
        console.log('LOST SIGNAL **********************', results);
        //Antes de enrutar se guarda en localStorage q mutua-test debe de mostrar
        //el modal que infoma q se ha redirigido por pérdida de conexión.
        //Solo en el caso q el modal informativo de pérdida de conexión
        //no se ha podido abrir en videoconferencia-main, y lo debe mostrar mutua-test
        localStorage.setItem('openLostSignalModal', 'true');
        document.location.href = document.location.protocol + "//" + document.location.host + '/' + document.location.search;
      }
    }
  }

  resetServiceData() {
    this.videoButtonSubscription && this.videoButtonSubscription.unsubscribe();
    this.forceTestStopBS.next(false);
    this.session = undefined;
    this.subscriberTest = undefined;
    this.publisher = undefined;
    this.publisherStream = undefined;
    this.cameraStatusBS = true;
    this.showLostSignalModalBS.next(false);
  }
}

